import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { reservasAPI } from "../../../../utils/funcionesAPI";
import Imagen from "./Imagen";
import Detalle from "./Detalle";
import Totales from "./Totales";
import { toast } from "react-toastify";
import { fechaEnRango, manejadorDeRespuesta } from "../../../../utils/Tools";

const ReservaFila = (props) => {
  const [showFacturas, setShowFacturas] = useState(false);
  const { reserva, modalidadTarjeta } = props;

  const tipoCliente = sessionStorage.getItem("tipoCliente");
  const token = sessionStorage.getItem("token");

  const buscarVouchers = (e, reserva) => {
    if (reserva.canal === "CDR") return;
    e.preventDefault();

    const datos = JSON.stringify({
      peticion: "traerVouchersPorReservaNuevo",
      reserva,
      token,
      canal: 'WEB'
    });
    reservasAPI(datos)
      .then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          window.open(respuesta.data, "_blank").focus();
        }
      })
      .catch((e) => {
        toast.error(
          "Ha ocurrido un error en buscar el voucher. Consulte con nuestros operadores.",
          {
            position: toast.POSITION.BOTTOM_CENTER,
          }
        );
      });
  };

  /*
  const abrirPDF = (e, vouchers) => {
    e.preventDefault();
    //FC descargo todos los vouchers que tenga
    for (var j = 0; j < vouchers.length; j++) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it shoul
      var byteCharacters = atob(vouchers[j].imagen);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);

      var newBlob = new Blob([byteArray], { type: "application/pdf" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.target = "_blank";
      link.download =
        props.reserva.producto.detalleWeb + " voucher Pedraza.pdf";
      link.click();
      window.open(data);
      //FC: si se quejan por que sigue tirando Error de Red al bajar el voucher, probar de sacar el revoke directamente
      /*
      setTimeout(function(){// For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data)
      }, 10000);

      //FC: guardar Contador del Voucher
      let datos = JSON.stringify({
        peticion: "marcarVoucherVisto",
        idStore: vouchers[j].id,
      });

      reservasAPI(datos).then((respuesta) => {});
    }
  };
*/

  const validarRangoFecha = (fecha) => {
    //var fecha = "2024-07-22"; // Fecha en formato aaaa-mm-dd
    if (fechaEnRango(fecha, -3)) {
      return true
    } 
    return false;
  };

  const btnImpresora = () => {
    const encodedData = window.btoa(reserva.numeroReserva); // encode a string
    const urlVoucher =
      reserva.canal !== "CDR"
        ? "#"
        : `/voucherCDR/voucher.php?nroReserva=${encodedData}`;

    return (
      <li className="nav-item">
        <a
          href={urlVoucher}
          className="nav-link"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => {
            buscarVouchers(event, reserva);
          }}
        >
          <i className="material-icons">&#xE415;</i> Voucher
        </a>
      </li>
    );
  };

  const handleVerFacturas = (e) => {
    e.preventDefault();

    if (reserva.facturas && reserva.facturas.length > 0) {
      setShowFacturas(!showFacturas);
      return;
    }

    toast.info("Aun no hay facturas generedas", {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  };
  /* if (window.confirm('¿Acepta descargar el/los vouchers?'))
      {reserva.cliente.cta_cte == 1 && reserva.estado !== 9 && reserva.vouchers.length > 0 ? btnImpresora() : null}
      {reserva.cliente.cta_cte == 0 && reserva.estado !== 9 && reserva.saldo <= 1 && reserva.vouchers.length > 0 ? btnImpresora() : null}*/

  /*      const btnImpresora = () => ( <li className="nav-item">
              <a href='#' className="nav-link" onClick={event =>  { if (window.confirm('¿Acepta descargar el/los vouchers?')) abrirPDF(event, reserva.vouchers)} }><i className="material-icons">&#xE415;</i> Voucher</a></li>
      )*/
  return (
    <div className="result" id="result-1">
      <div className="row">
        {/*SLIDER*/}
        <Imagen imagenes={reserva.producto.destino.imagenes} />
        {/*PARTE CENTRAL*/}
        <Detalle reserva={reserva} />
        {/*PARTE DERECHA*/}
        <Totales reserva={reserva} />
        <ul
          className={`nav nav-pills misReservasLinks ${
            reserva.estado !== 9
              ? "misReservasLinksActivas"
              : "misReservasLinksCanceladas"
          } `}
          id="pills-destino"
          role="tablist"
        >
          {reserva.estado !== 9 &&
            reserva.totalReservaAgenciaWeb > 0 &&
            tipoCliente !== "IND" && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href={`/liquidacionAgencias/liquidacion.php?nroReserva=${reserva.numeroReserva}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="material-icons">&#xE415;</i> Liquidacion
                </a>
              </li>
            )}
          {/*VOUCHER*/}
          {reserva.estado !== 9 &&
            validarRangoFecha(reserva.charter.fechaSalida) &&
            btnImpresora()}

          {reserva.estado !== 9 && reserva.saldo > 1 && (
            <li className="nav-item">
              <Link
                className="nav-link"
                to={`/panel-mis-reservas/informar-deposito/${reserva.numeroReserva}`}
              >
                <i className="material-icons">&#xE84F;</i> Informar Dep / Transf
              </Link>
            </li>
          )}

          {/*reserva.estado !== 9 && reserva.saldo > 0 ? <li className="nav-item">
                <Link className="nav-link" to={`/panel-mis-reservas/mercadoPago/${reserva.numeroReserva}`}><i className="material-icons">&#xE8A1;</i> Mercado Pago</Link>
              </li> : null */}

          {reserva.estado !== 9 &&
            reserva.saldo > 1 &&
            reserva.producto.moneda.codigoMoneda === "PES" && (
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/panel-mis-reservas/${modalidadTarjeta}/${reserva.numeroReserva}`}
                >
                  <i className="material-icons">&#xE8A1;</i> Pagar con tarjeta
                </Link>
              </li>
            )}

          {reserva.estado !== 9 &&
            reserva.saldo > 1 &&
            tipoCliente !== "IND" && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    props.onGenerarLinkDePago(reserva);
                  }}
                >
                  <i className="material-icons">&#xE8A1;</i> Link de Pago
                </a>
              </li>
            )}

          {/*reserva.estado !== 9 && reserva.saldo > 0 ? <li className="nav-item">
                <a className="nav-link" href={`/tarjetaTelefonica/index.php?reserva=${reserva.numeroReserva}`} ><i className="material-icons">&#xE8A1;</i>Pagar con tarjeta</a>
              </li> : null */}
          {/* FACTURA PARA AGENCIAS - FREELANCE -ETC */}
          {reserva.estado !== 9 &&
            reserva.saldo <= 1 &&
            reserva.facturaSolicitada == null && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    props.onSolicitarFacturaClick(false, reserva.numeroReserva);
                  }}
                >
                  <i className="material-icons">description</i>
                  Solicitar Factura
                </a>
              </li>
            )}

          {/* Cancelar Solicitud de Facturas
          reserva.estado !== 9 &&
            tipoCliente !== "IND" &&
            reserva.facturaSolicitada != null && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "¿Está seguro de eliminar la solicitud de factura?"
                      )
                    )
                      props.onBorrarSolicitudDeFactura(reserva.numeroReserva);
                  }}
                >
                  <i className="material-icons">description</i>
                  Cancelar Solicitud de Factura
                </a>
              </li>
                ) */}

          {reserva.estado !== 9 && (
            <li className="nav-item" style={{ position: "relative" }}>
              <a className="nav-link" href="#" onClick={handleVerFacturas}>
                <i className="material-icons">&#xE415;</i> Ver Factura/s
              </a>
              {showFacturas && (
                <div
                  className="cuadroPuntosEmbarques"
                  style={{
                    zIndex: "9",
                    position: "absolute",
                    left: "0",
                    textAlign: "left",
                    width: "100%",
                    backgroundColor: "rgb(110 173 206)",
                  }}
                >
                  {reserva.facturas &&
                    reserva.facturas.map((factura) => {
                      return (
                        <a
                          key={factura.numero}
                          className="nav-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={factura.url}
                        >
                          <i className="material-icons">description</i>
                          {factura.denominacion} N° {factura.numero}
                        </a>
                      );
                    })}
                </div>
              )}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};
//FC: el withRouter es para poder hacer un this.props.history.push('/')
export default withRouter(ReservaFila);

/*
<td><Link to='/'>V</Link></td>
{reserva.estado !== 9 && reserva.saldo > 0 ? <td><Link to={`panel-mis-reservas/informar-deposito/${reserva.numeroReserva}`}>Informar</Link></td> : <td></td>}
{reserva.estado !== 9 && reserva.saldo > 0 ? <td><Link to={`panel-mis-reservas/mercadoPago/${reserva.numeroReserva}`}>Tarjeta Cred</Link></td> : <td></td>}
{reserva.estado !== 9 && reserva.saldo > 0 ? <td><Link to={`http://pedrazavyt.com.ar/tarjetaTelefonica/index.php?reserva=${reserva.numeroReserva}`}>Visa Telef</Link></td> : <td></td>}

*/



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/index.js